
const digest = '5c8e85a4800140ef38cf510d10feb77cb0e0a6470d66b840fe27ea8dc9acd411';
const classes = {"wrapper":"_wrapper_yi467_1","formWrapper":"_formWrapper_yi467_8"};
const css = `._wrapper_yi467_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  height: 100%;
  gap: 20px;
}
._wrapper_yi467_1 ._formWrapper_yi467_8 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  